
import React from 'react';
import { Switch } from 'react-router-dom';

import {
  ChangePudoPoint,
  ChangePudoPointCallback,
  Page404,
  RetryDelivery,
  RetryDeliveryCallback,
  MissingID,
  MissingIDCallback,
  SmsFeePaymentPage,
  SmsFeePaymentCallback,
  Sms5Kg,
  SmsOptIn,
  SmsOptOut,
  Tracking,
  TrackingV2,
  UpgradeDelivery,
  UpgradeDeliveryCallback
} from '../../pages';
import { BuyerPersonalDetailsUpdate } from '../../pages/BuyerPersonalDetailsUpdate';
import DropOffPoint from '../../pages/DropOffPoint';
import { FormsThanks } from '../../pages/FormsThanks';
import PayDuties from '../../pages/PayDuties/PayDuties';
import PayDutiesCallback from '../../pages/PayDuties/PayDutiesCallback';
import PayInspection from '../../pages/PayInspection/PayInspection';
import CreditGuardPaymentCallback from '../CreditGuardPaymentCallback';
import { SMS_FEE_PAYMENT_PAGES } from '../../config/smsFeePaymentPages';
import { PublicLayout } from '../Layouts';
import { AppRoute } from './AppRoute';

export const Routes = () => (
  <Switch>
    <AppRoute
      path='/payDuties/callback/:status'
      exact
      component={PayDutiesCallback}
      publicAccess
    />
    <AppRoute path='/payDuties/:id?' exact component={PayDuties} publicAccess />
    <AppRoute
      path='/payInspection/callback/:status'
      exact
      component={PayDutiesCallback}
      publicAccess
    />
    <AppRoute path='/payInspection/:id/:inspection?' exact component={PayInspection} publicAccess />
    <AppRoute
      path='/forms/:formID/thanks'
      exact
      component={FormsThanks}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute path='/track/:xltID?' exact component={Tracking} publicAccess />
    <AppRoute
      path='/tracking/:xltID?'
      exact
      component={TrackingV2}
      publicAccess
    />
    <AppRoute
      path='/returnpudo/:rxltID?'
      exact
      component={DropOffPoint}
      publicAccess
    />
    <AppRoute
      path='/'
      exact
      component={Page404}
      layout={PublicLayout}
      publicAccess
    />
    <AppRoute path='/Page40411' exact component={Page404} publicAccess />
    <AppRoute
      path='/SMS/Over100/:parcelID'
      exact
      component={Sms5Kg}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/upgradeDelivery/callback/:status'
      exact
      component={UpgradeDeliveryCallback}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/upgradeDelivery/:parcelID'
      exact
      component={UpgradeDelivery}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/retryDelivery/callback/:status'
      exact
      component={RetryDeliveryCallback}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/retryDelivery/:parcelID'
      exact
      component={RetryDelivery}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/missingID/callback/:status'
      exact
      component={MissingIDCallback}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/missingID/:parcelID'
      exact
      component={MissingID}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/changePudoPoint/callback/:status'
      exact
      component={ChangePudoPointCallback}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/changePudoPoint/:parcelID'
      exact
      component={ChangePudoPoint}
      publicAccess
      layout={PublicLayout}
    />
    {Object.values(SMS_FEE_PAYMENT_PAGES).flatMap((cfg) => [
      <AppRoute
        key={`${cfg.publicPath}-callback`}
        path={`/${cfg.publicPath}/callback/:status`}
        exact
        component={SmsFeePaymentCallback}
        publicAccess
        layout={PublicLayout}
      />,
      <AppRoute
        key={`${cfg.publicPath}-parcel`}
        path={`/${cfg.publicPath}/:parcelID`}
        exact
        component={SmsFeePaymentPage}
        publicAccess
        layout={PublicLayout}
      />,
    ])}
    <AppRoute
      path='/parcels/creditguard/process_payment'
      exact
      component={CreditGuardPaymentCallback}
      resource='PUBLIC'
      publicAccess
    />
    <AppRoute
      path='/SmsOptOut/:parcelID/:type?'
      exact
      component={SmsOptOut}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/SmsOptIn/:blockedNumberID/:type?'
      exact
      component={SmsOptIn}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute
      path='/BuyerPersonalDetailsUpdate/:parcelID/'
      exact
      component={BuyerPersonalDetailsUpdate}
      publicAccess
      layout={PublicLayout}
    />
    <AppRoute component={Page404} publicAccess />
  </Switch>
);
